export default {
    setCmpProjHome (state, resp) {
        state.cmpProjHome = resp
    },
    setCmpProjHomeLoadStatus (state, status) {
        state.cmpProjHomeLoadStatus = status
    },

    setCmpProjHasChangeForInputBarStatus (state, status) {
        state.cmpProjHasChangeForInputBarStatus = status
    },

    /** 一覧案件情報更新 **/
    setChangeCmpProjInfoCommon (state, resp) {
        state.changeCmpProjInfoCommon = resp.data
    },
    setChangeCmpProjInfoCommonStatus (state, status) {
        state.changeCmpProjInfoCommonStatus = status
    },
    resetChangeCmpProjInfoCommon (state) {
        state.changeCmpProjInfoCommon = {}
    },
    
    /** 案件情報 **/
    setCmpProjOperat (state, operat) {
        if (operat == 'success') {
            state.cmpProjOperat = 'show'
        } else {
            state.cmpProjOperat = operat == 'create_confirm' ? 'create' : 'edit'
        }
    },
    resetCmpProjOperat (state) {
        state.cmpProjOperat = ""
    },
    setCmpProjInfo (state, resp) {
        state.cmpProjInfo = resp
    },
    setSaveCmpProjInfoStatus (state, status) {
        state.saveCmpProjInfoStatus = status
    },
    setCmpProjInfoLoadStatus (state, status) {
        state.cmpProjInfoLoadStatus = status
    },
    setCmpProjDelStatus (state, status) {
        state.cmpProjDelStatus = status
    },
    setCmpProjOffStatus (state, status) {
        state.cmpProjOffStatus = status
    },

    // 公開
    setCmpProjPubliced (state, resp) {
        state.cmpProjPubliced = resp
    },
    setCmpProjPublicStatus (state, status) {
        state.cmpProjPublicStatus = status
    },

    // 単価公開
    setCmpProjPricePubliced (state, resp) {
        state.cmpProjPricePubliced = resp
    },
    setCmpProjPricePubStatus (state, status) {
        state.cmpProjPricePubStatus = status
    },

    // 備考
    setCmpProjNoted (state, resp) {
        state.cmpProjNoted = resp
    },
    setCmpProjNoteStatus (state, status) {
        state.cmpProjNoteStatus = status
    },

    // 言語分析
    setCmpLangGraph (state, resp) {
        state.cmpLangGraph = resp
    },
    setCmpLangGraphLoadStatus (state, status) {
        state.cmpLangGraphLoadStatus = status
    }
}
